
import { uploadFile } from '@/utils/utility-manager'
import authModule from '@/store/auth'
import Vue from 'vue'
import whitelabel from '@/store/whitelabel'
import dashboard from '@/store/dashboard'
export default Vue.extend({
  data() {
    return {
      file: null as File | null
    }
  },
  methods: {
    async upload() {
      try {
        if (!authModule.user) throw new Error('Bitte anmelden')
        if (!whitelabel.whitelabel)
          throw new Error('Bitte ein Whitelabel auswählen')
        if (!this.file) return console.error('Bitte eine Datei auswählen')
        console.log(
          await uploadFile(
            this.file,
            `/admin/${whitelabel.whitelabel.slug}/users/import`,
            'file'
          )
        )
        dashboard.newMessage('Import erfolgreich')
      } catch (err) {
        dashboard.newError('Import fehlgeschlagen')
      }
    }
  }
})
